package co.maytes.standupbot.dashboard.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.style.StyleScope
import org.jetbrains.compose.web.css.CSSMediaQuery

val HoverFinePointerMedia = CSSMediaQuery.Raw("(hover: hover) and (pointer: fine)")

fun StyleScope.hoverFinePointer(createModifier: () -> Modifier) =
    cssRule(HoverFinePointerMedia, ":hover", createModifier)
